import clsx from 'clsx';

interface Props {
	className?: string;
}

export const Skeleton = ({ className }: Props) => (
	<div className={clsx('animate-pulse bg-gray-200', className)} />
);
